import { Box, Typography, Tooltip } from "@mui/material";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const QuantityNumbers = (props) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("sm"));
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <Tooltip title={props.quantityFrom ? props.quantityFrom : ""}>
        <Typography
          sx={{ fontWeight: "bold", fontSize: [16, 24] }}
          //style={{ fontWeight: "bold", fontSize: matches ? 24 : 16 }}
          variant="h3"
        >
          {props.current}
        </Typography>
      </Tooltip>

      <Tooltip title={props.quantityTo ? props.quantityTo : ""}>
        <Typography
          style={{ marginLeft: 8, fontSize: matches ? 14 : 10 }}
          variant="h6"
        >
          /{props.max}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default QuantityNumbers;
